export interface Coupon {
  id?: number;
  code: string;
  title: string;
  available: number;
  discount_currency: string;
  discount_price: number;
  // discount_percentage
  created_at?: string;
  updated_at?: string;
  active?: boolean;
}

function New(): Coupon {
  return {
    code: '',
    title: '',
    available: 200,
    discount_currency: 'ZAR',
    discount_price: 0,
  };
}

export default {
  New
};
